import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'upmarket-product_details_page_sku_expandable-click';
/**
 * Event to track when the expandable SKU display is expanded or collapsed on the Product details page. This display is shown for open sizing SKUs texts that are very long and can&#39;t fit on one line. First parameter is one of &quot;expand&quot; or &quot;collapse&quot;: whether or not the user expanded or collapsed the display. The second parameter is the SKU itself.
 */
export function trackUpmarketProductDetailsPageSkuExpandableClick(expand_or_collapse, SKU2) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { expand_or_collapse, SKU2 },
    });
}
